import styled from 'styled-components';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Container = styled.div`
  margin-top: 5px;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
`;

const OtherDetails = styled(TextLayoutComponent.Bold)`
  margin-bottom: 10px;
`;

const Detail = styled(TextLayoutComponent)`
  margin-bottom: 5px;
`;

const ContainerSpace = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ContainerParticipants = styled.div`
  display: flex;
`;

export {
  Container,
  Detail,
  OtherDetails,
  ContainerSpace,
  ContainerParticipants,
};
